import { useMutation, useQuery } from "@tanstack/react-query"
import {
  getNotificationDevices,
  sendTestNotification,
} from "../api/notificationSettingsApi"

export const NOTIFICATION_SETTINGS_QUERY_KEY = "notification-settings"

export const useNotificationDevices = () =>
  useQuery({
    queryKey: [NOTIFICATION_SETTINGS_QUERY_KEY, "devices"],
    queryFn: getNotificationDevices,
  })

export const useSendTestNotification = () =>
  useMutation({
    mutationFn: sendTestNotification,
  })
